import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, totalPages, onChange, className = "" }) {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="pagination">
      <button
        data-testid="page-prev" disabled={page <= 1} onClick={() => onChange(page - 1)}
        className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium border border-slate-200 text-slate-500 disabled:opacity-30 hover:bg-slate-50 hover:border-slate-300 transition"
      >
        <ChevronLeft className="w-3.5 h-3.5" /> Prev
      </button>
      {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
        let pageNum;
        if (totalPages <= 7) {
          pageNum = i + 1;
        } else if (page <= 4) {
          pageNum = i + 1;
        } else if (page >= totalPages - 3) {
          pageNum = totalPages - 6 + i;
        } else {
          pageNum = page - 3 + i;
        }
        return (
          <button key={pageNum} onClick={() => onChange(pageNum)}
            className={`w-8 h-8 rounded-lg text-xs font-semibold transition
              ${pageNum === page
                ? "bg-sky-500 text-white shadow-sm shadow-sky-200"
                : "text-slate-500 hover:bg-slate-50 hover:text-slate-700"}`}>
            {pageNum}
          </button>
        );
      })}
      <button
        data-testid="page-next" disabled={page >= totalPages} onClick={() => onChange(page + 1)}
        className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium border border-slate-200 text-slate-500 disabled:opacity-30 hover:bg-slate-50 hover:border-slate-300 transition"
      >
        Next <ChevronRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
